import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Card, Row, Col, Table, Button, Modal, Form } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../services/api";
import { getCurrentUser, tiposAcesso, kitsStatus, formataDataExibicao } from "../../common/utils";

// Tela do MÉDICO para SOLICITAR kits do programa (menu liberado por configuracao
// medico_solicita_kit=true). O médico visualiza suas solicitações e solicita novas (informando o
// endereço de entrega). Sem editar/alterar status — a navegadora processa e envia o kit depois.
class MedicoKits extends Component {
    constructor(props) {
        super(props);
        this.ufOptions = {
            "AC": "Acre", "AL": "Alagoas", "AP": "Amapá", "AM": "Amazonas", "BA": "Bahia",
            "CE": "Ceará", "DF": "Distrito Federal", "ES": "Espírito Santo", "GO": "Goiás",
            "MA": "Maranhão", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul", "MG": "Minas Gerais",
            "PA": "Pará", "PB": "Paraíba", "PR": "Paraná", "PE": "Pernambuco", "PI": "Piauí",
            "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte", "RS": "Rio Grande do Sul",
            "RO": "Rondônia", "RR": "Roraima", "SC": "Santa Catarina", "SP": "São Paulo",
            "SE": "Sergipe", "TO": "Tocantins",
        };
        this.state = {
            prestadorId: null,
            programaId: null,
            kits: [],
            loading: true,
            kitsProgramaOptions: [],
            showModal: false,
            enviando: false,
            kitSelecionadoId: "",
            quantidade: 1,
            descricao: "",
            // Endereço de entrega
            enderecos: [],
            enderecoSelecionado: "",
            showModalNovoEndereco: false,
            salvandoEndereco: false,
            novoEndereco: { nome: "", cep: "", endereco: "", numero: "", complemento: "", bairro: "", cidade: "", uf: "" },
        };
    }

    componentDidMount() {
        const dados_usuario = getCurrentUser();
        const programaId = dados_usuario?.ambiente_programa_id || null;

        // prestador_id vem de tiposAcesso() (getCurrentUser pode nao te-lo antes de escolher o programa)
        const tipos_acesso = tiposAcesso();
        const chavePrestador = Object.keys(tipos_acesso).find(k => tipos_acesso[k] && tipos_acesso[k]["prestador_id"]);
        const prestadorId = chavePrestador ? tipos_acesso[chavePrestador]["prestador_id"] : null;

        this.setState({ prestadorId, programaId }, () => {
            this.carregarKits();
            this.carregarKitsPrograma();
            this.buscarEnderecos();
        });
    }

    carregarKits = async () => {
        const { prestadorId } = this.state;
        if (!prestadorId) {
            this.setState({ loading: false });
            return;
        }
        this.setState({ loading: true });
        try {
            const resp = await api.get(`/pessoas/prestadores/kits/`, { params: { prestador_id: prestadorId } });
            this.setState({ kits: resp.data.results || [], loading: false });
        } catch (err) {
            console.error("Erro ao carregar kits do médico:", err);
            this.setState({ loading: false });
        }
    };

    carregarKitsPrograma = async () => {
        const { programaId } = this.state;
        if (!programaId) return;
        try {
            const resp = await api.get(`/programas/kits/`, { params: { programa_id: programaId } });
            const options = (resp.data.results || resp.data || []).map(k => ({ id: k.id, titulo: k.titulo }));
            this.setState({
                kitsProgramaOptions: options,
                kitSelecionadoId: options.length === 1 ? String(options[0].id) : "",
            });
        } catch (err) {
            console.error("Erro ao buscar kits do programa:", err);
        }
    };

    buscarEnderecos = async () => {
        const { prestadorId } = this.state;
        if (!prestadorId) return;
        try {
            const resp = await api.get(`/enderecos/`, { params: { prestador_id: prestadorId } });
            this.setState({ enderecos: resp.data.results || [] });
        } catch (err) {
            console.error("Erro ao buscar endereços:", err);
            this.setState({ enderecos: [] });
        }
    };

    enderecoLabel = (e) => {
        const partes = [e.endereco, e.numero, e.bairro, e.cidade && `${e.cidade}/${e.uf || ""}`].filter(Boolean);
        return `${e.nome ? e.nome + " - " : ""}${partes.join(", ")}`;
    };

    abrirModal = () => this.setState({ showModal: true, descricao: "", quantidade: 1, enderecoSelecionado: "" });
    fecharModal = () => this.setState({ showModal: false });

    handleChangeNovoEndereco = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({ novoEndereco: { ...prev.novoEndereco, [name]: value } }));
    };

    onChangeCepNovoEndereco = (e) => {
        const cep = e.target.value.replace(/\D/g, "");
        this.setState(prev => ({ novoEndereco: { ...prev.novoEndereco, cep } }));
        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(r => r.json())
                .then(d => {
                    if (!d.erro) {
                        this.setState(prev => ({
                            novoEndereco: {
                                ...prev.novoEndereco,
                                endereco: d.logradouro || prev.novoEndereco.endereco,
                                bairro: d.bairro || prev.novoEndereco.bairro,
                                cidade: d.localidade || prev.novoEndereco.cidade,
                                uf: d.uf || prev.novoEndereco.uf,
                            },
                        }));
                    }
                })
                .catch(() => {});
        }
    };

    salvarNovoEndereco = async (e) => {
        e.preventDefault();
        const { t } = this.props;
        const { novoEndereco, prestadorId } = this.state;
        const MySwal = withReactContent(Swal);

        if (!novoEndereco.nome || !novoEndereco.cep || !novoEndereco.endereco || !novoEndereco.numero || !novoEndereco.bairro || !novoEndereco.cidade || !novoEndereco.uf) {
            MySwal.fire({ icon: "warning", title: t("common:alert.attention"), html: <p>{t("medicoKits:alert.fillAddress")}</p>, showCloseButton: true });
            return;
        }

        this.setState({ salvandoEndereco: true });
        try {
            const resp = await api.post(`/enderecos/`, {
                ...novoEndereco,
                complemento: novoEndereco.complemento || "",
                prestador_id: prestadorId,
            });
            const criado = resp.data;
            this.setState(prev => ({
                enderecos: [...prev.enderecos, criado],
                enderecoSelecionado: String(criado.id),
                showModalNovoEndereco: false,
                salvandoEndereco: false,
                novoEndereco: { nome: "", cep: "", endereco: "", numero: "", complemento: "", bairro: "", cidade: "", uf: "" },
            }));
        } catch (err) {
            console.error("Erro ao salvar endereço:", err);
            this.setState({ salvandoEndereco: false });
            MySwal.fire({ icon: "error", title: t("common:alert.error"), html: <p>{t("medicoKits:alert.saveAddressFailed")}</p>, showCloseButton: true });
        }
    };

    solicitarKit = async (e) => {
        e.preventDefault();
        const { t } = this.props;
        const { prestadorId, kitSelecionadoId, quantidade, descricao, enderecoSelecionado } = this.state;
        const MySwal = withReactContent(Swal);

        if (!kitSelecionadoId) {
            MySwal.fire({ icon: "warning", title: t("common:alert.attention"), html: <p>{t("medicoKits:alert.selectKit")}</p>, showCloseButton: true });
            return;
        }
        if (!enderecoSelecionado) {
            MySwal.fire({ icon: "warning", title: t("common:alert.attention"), html: <p>{t("medicoKits:alert.selectAddress")}</p>, showCloseButton: true });
            return;
        }

        this.setState({ enviando: true });
        try {
            const hoje = new Date().toISOString().slice(0, 10);
            await api.post(`/pessoas/prestadores/kits/`, {
                prestador_id: prestadorId,
                programa_kit_id: kitSelecionadoId,
                quantidade: parseInt(quantidade) || 1,
                descricao: descricao || null,
                endereco_id: enderecoSelecionado,
                data_solicitacao: hoje,
                solicitado_por_medico: true,
            });

            this.setState({ showModal: false, enviando: false });
            MySwal.fire({
                icon: "success",
                title: t("medicoKits:alert.sentTitle"),
                html: <p>{t("medicoKits:alert.sentText")}</p>,
                showCloseButton: true,
            });
            this.carregarKits();
        } catch (err) {
            console.error("Erro ao solicitar kit:", err);
            this.setState({ enviando: false });
            MySwal.fire({ icon: "error", title: t("common:alert.error"), html: <p>{t("medicoKits:alert.sendFailed")}</p>, showCloseButton: true });
        }
    };

    renderRows = () => {
        const { t } = this.props;
        const { kits } = this.state;
        if (kits.length === 0) {
            return (
                <tr>
                    <td colSpan={4}>{t("medicoKits:table.empty")}</td>
                </tr>
            );
        }
        return kits.map(kit => (
            <tr key={kit.id}>
                <td>{kit.dados_kit?.titulo || kit.descricao || "-"}</td>
                <td>{kit.quantidade || "-"}</td>
                <td>{kit.data_solicitacao ? formataDataExibicao(kit.data_solicitacao) : "-"}</td>
                <td><span className="badge bg-secondary">{kit.status ? t(`enums:statusKit.${kit.status}`, { defaultValue: kitsStatus[kit.status] || kit.status }) : "-"}</span></td>
            </tr>
        ));
    };

    render() {
        const { t } = this.props;
        const { loading, kitsProgramaOptions, showModal, enviando, kitSelecionadoId, quantidade, descricao,
            enderecos, enderecoSelecionado, showModalNovoEndereco, salvandoEndereco, novoEndereco } = this.state;

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{t("medicoKits:pageTitle")}</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" className="mb-3" size="sm" onClick={this.abrirModal} disabled={kitsProgramaOptions.length === 0}>
                            <FaPlus /> {t("medicoKits:requestKit")}
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>{t("medicoKits:table.kit")}</th>
                                    <th>{t("medicoKits:table.quantity")}</th>
                                    <th>{t("medicoKits:table.requestDate")}</th>
                                    <th>{t("medicoKits:table.status")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={4}>{t("common:label.loading")}</td></tr>
                                ) : (
                                    this.renderRows()
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                <Modal show={showModal} onHide={this.fecharModal} centered>
                    <Form onSubmit={this.solicitarKit}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("medicoKits:requestKit")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("medicoKits:form.kit")} <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    value={kitSelecionadoId}
                                    onChange={(e) => this.setState({ kitSelecionadoId: e.target.value })}
                                >
                                    <option value="">{t("medicoKits:form.selectKit")}</option>
                                    {kitsProgramaOptions.map(k => (
                                        <option key={k.id} value={k.id}>{k.titulo}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("medicoKits:form.quantity")} <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    value={quantidade}
                                    onChange={(e) => this.setState({ quantidade: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("medicoKits:form.address")} <span className="text-danger">*</span></Form.Label>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        as="select"
                                        value={enderecoSelecionado}
                                        onChange={(e) => this.setState({ enderecoSelecionado: e.target.value })}
                                    >
                                        <option value="">{t("medicoKits:form.selectAddress")}</option>
                                        {enderecos.map(en => (
                                            <option key={en.id} value={en.id}>{this.enderecoLabel(en)}</option>
                                        ))}
                                    </Form.Control>
                                    <Button variant="light" size="sm" type="button" onClick={() => this.setState({ showModalNovoEndereco: true })}>
                                        <FaPlus /> {t("medicoKits:form.new")}
                                    </Button>
                                </div>
                                {enderecos.length === 0 && (
                                    <Form.Text className="text-muted">{t("medicoKits:form.noAddress")}</Form.Text>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-1">
                                <Form.Label>{t("medicoKits:form.notes")}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder={t("medicoKits:form.notesPlaceholder")}
                                    value={descricao}
                                    onChange={(e) => this.setState({ descricao: e.target.value })}
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" onClick={this.fecharModal}>{t("common:button.cancel")}</Button>
                            <Button type="submit" variant="secondary" disabled={enviando}>
                                {enviando ? <span className="spinner-border spinner-border-sm" /> : t("medicoKits:form.submit")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <Modal show={showModalNovoEndereco} onHide={() => this.setState({ showModalNovoEndereco: false })} centered>
                    <Form onSubmit={this.salvarNovoEndereco}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("medicoKits:address.title")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.placeName")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="nome" value={novoEndereco.nome} onChange={this.handleChangeNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.zipCode")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="cep" inputMode="numeric" placeholder={t("medicoKits:address.zipPlaceholder")} value={novoEndereco.cep} onChange={this.onChangeCepNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.street")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="endereco" value={novoEndereco.endereco} onChange={this.handleChangeNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.number")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="numero" value={novoEndereco.numero} onChange={this.handleChangeNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={9}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.complement")}</Form.Label>
                                        <Form.Control type="text" name="complemento" value={novoEndereco.complemento} onChange={this.handleChangeNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.neighborhood")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="bairro" value={novoEndereco.bairro} onChange={this.handleChangeNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={5}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.city")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="cidade" value={novoEndereco.cidade} onChange={this.handleChangeNovoEndereco} />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("medicoKits:address.state")} <span className="text-danger">*</span></Form.Label>
                                        <Form.Control as="select" name="uf" value={novoEndereco.uf} onChange={this.handleChangeNovoEndereco}>
                                            <option value="">{t("medicoKits:address.state")}</option>
                                            {Object.keys(this.ufOptions).map(sigla => (
                                                <option key={sigla} value={sigla}>{sigla}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" type="button" onClick={() => this.setState({ showModalNovoEndereco: false })}>{t("common:button.cancel")}</Button>
                            <Button type="submit" variant="secondary" disabled={salvandoEndereco}>
                                {salvandoEndereco ? <span className="spinner-border spinner-border-sm" /> : t("medicoKits:address.save")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}

MedicoKits.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation(["medicoKits", "common", "enums"])(MedicoKits);
